/** Roll numbers show as four digits everywhere (1 -> "0001"), as on the answer sheet. */
export const ROLL_MAX = 9999;

export function formatRoll(roll: number | null | undefined): string {
  return roll == null ? '—' : String(roll).padStart(4, '0');
}
